import { motion } from "framer-motion";

const Section = ({ id, title, children }) => {
  return (
    <section id={id} className="py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-6">
        {title && (
          <motion.h2
            className="relative text-left text-4xl md:text-5xl font-display font-bold tracking-tight mb-10 inline-block"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
          >
            <span
              className="relative z-10 bg-gradient-to-r from-brand-teal via-brand-blue to-brand-violet bg-clip-text text-transparent drop-shadow-[0_0_8px_rgba(75,95,255,0.35)]"
              style={{
                backgroundSize: "200% auto",
                backgroundPosition: "0 50%",
                WebkitBackgroundClip: "text",
              }}
            >
              {title}
            </span>
            <span className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-brand-teal/40 via-brand-blue/30 to-brand-violet/40 rounded-full blur-[2px] opacity-80" />
          </motion.h2>
        )}

        <motion.div
          className="w-full max-w-5xl text-left text-slate-200 leading-relaxed"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.05, ease: 'easeOut' }}
        >
          {children}
        </motion.div>
      </div>
    </section>
  );
};

export default Section;
